import * as React from 'react'
import { cn } from 'lib/utils'

export interface SpinnerProps extends React.HTMLAttributes<HTMLDivElement> {
	type?: 'linear' | 'circular'
	width?: string
	containerHeight?: string
}

const Spinner = React.forwardRef<HTMLDivElement, SpinnerProps>(
	({ className, type = 'linear', width = '50', containerHeight, ...props }, ref) => {
		if (type === 'circular') {
			return (
				<div
					ref={ref}
					data-testid="ShadcnSpinner"
					className={cn('flex flex-col items-center justify-center w-full', className)}
					style={{ height: containerHeight || '100%' }}
					{...props}
				>
					<svg
						className="animate-spin text-primary"
						style={{ width: `${width}px`, height: `${width}px` }}
						viewBox="0 0 50 50"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<circle
							className="opacity-25"
							cx="25"
							cy="25"
							r="20"
							stroke="currentColor"
							strokeWidth="5"
						/>
						<path
							className="opacity-75"
							fill="currentColor"
							d="M25 5a20 20 0 0 1 20 20h-5a15 15 0 0 0-15-15V5z"
						/>
					</svg>
					<p className="mt-2 text-sm text-muted-foreground">Loading. . .</p>
				</div>
			)
		}

		return (
			<div
				ref={ref}
				data-testid="ShadcnSpinner"
				className={cn('w-full', className)}
				{...props}
			>
				<div className="h-1 w-full bg-muted overflow-hidden rounded-full">
					<div className="h-full bg-primary rounded-full w-1/3 animate-[indeterminate_1.5s_ease-in-out_infinite]" />
				</div>
				<p className="mt-1 text-sm text-muted-foreground">Loading. . .</p>
			</div>
		)
	},
)
Spinner.displayName = 'Spinner'

export { Spinner }
